import { Component } from "@angular/core";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { EditNameComponent } from "src/app/modals/editname/editname.component";
import { UploadButtonCompleteResponse } from "src/app/directives/uploadbutton.directive";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PlayerStatus } from "src/app/models/playerstatus";
import { LibrarySound } from "src/app/models/librarysound";
import { Exam } from "src/app/models/exam";

@Component({
  templateUrl: "./librarysounds.component.html",
  styleUrls: ["./librarysounds.component.scss"],
})
export class LibrarySoundsComponent {
  exam: Exam;
  uploadUrl: string;
  uploadFolder: string;
  uploadingSound: boolean;
  uploadingProgress: number;
  soundPlayer: Map<string, PlayerStatus>;

  constructor(
    private modalDialogService: ModalDialogService,
    private examService: ExamService,
    private serverResourcesPathPipe: ServerResourcesPathPipe,
  ) {
    this.exam = this.examService.currentExam;
    this.uploadUrl = Config.SERVER_API_UPLOAD;
    this.uploadFolder = Config.SERVER_UPLOADFOLDER;
    this.uploadingSound = false;
    this.soundPlayer = new Map();
  }

  onUploadProgress(progress: number): void {
    this.uploadingSound = true;
    this.uploadingProgress = progress;
  }
  onUploadComplete(data: UploadButtonCompleteResponse): void {
    let sound = new LibrarySound();

    let count = 0;
    let found: boolean;
    do {
      found = false;
      sound.name = data.filename + (count == 0 ? "" : "_" + count);
      if (this.exam.library.checkSoundNameInUse(sound.name)) {
        found = true;
      }
    } while (found);

    sound.source = data.filename;
    this.exam.library.sounds.push(sound);
    this.uploadingSound = false;
  }
  onUploadError(msg: string): void {
    this.modalDialogService.showAlert(Config.APP_NAME, msg);
    this.uploadingSound = false;
  }

  onPlaySound(sound: LibrarySound): void {
    let player: PlayerStatus = this.soundPlayer.get(sound.name);
    if (!player) {
      player = {
        sound: sound,
        isPlaying: false,
        audio: new Audio(),
      };
      player.audio.onloadeddata = function() {
        player.audio.play();
      };
      player.audio.onplaying = function() {
        player.isPlaying = true;
      };
      player.audio.onpause = function() {
        player.isPlaying = false;
      };
      player.audio.src = this.serverResourcesPathPipe.transform(sound.source, this.uploadFolder, "no_sanitizer");
      player.audio.load();

      this.soundPlayer.set(sound.name, player);
    } else {
      if (player.isPlaying) {
        player.audio.pause();
      } else {
        player.audio.play();
        player.audio.currentTime = 0;
      }
    }
  }

  onEditSound(sound: LibrarySound): void {
    const modal = this.modalDialogService.createModal();
    modal.setTitle("Sound name");
    modal.setButtonCancelOk();
    const component = modal.setBodyComponent(EditNameComponent);
    component.createFormWithValues(sound.name);
    component.onFormStatusChanges.subscribe(invalid => {
      modal.buttons[1].disabled = invalid;
    });
    modal.show().subscribe(
      button => {
        if (button.index == 0) {
          modal.close();
        } else if (button.index == 1) {
          if (component.hasErrors()) {
            return;
          }
          const formValues = component.values;
          formValues.name = formValues.name.trim();
          if (this.exam.library.checkSoundNameInUse(formValues.name, sound)) {
            this.modalDialogService.showAlert(Config.APP_NAME, "The name is already in use");
            return;
          }
          sound.name = formValues.name;
          modal.close();
        }
      },
      error => {},
      () => {
        this.modalDialogService.dismissModal(modal);
      },
    );
  }

  onDeleteSound(sound: LibrarySound): void {
    let index = this.exam.library.sounds.indexOf(sound);
    if (index >= 0) {
      this.modalDialogService.showConfirmation(Config.APP_NAME, "Are you sure to delete the sound?", () => {
        // Yes
        this.exam.library.sounds.splice(index, 1);
      });
    }
  }

  isPlaying(sound: LibrarySound): boolean {
    let player = this.soundPlayer.get(sound.name);
    if (!player) {
      return false;
    }
    return player.isPlaying;
  }
}
